// Single source of truth for FAQs - used by both UI (FAQ.jsx) and Schema markup (FAQSchema.jsx)
export const faqs = [
  {
    id: 1,
    question: '¿Qué tipos de generadores ofrecen en renta?',
    answer:
      'Ofrecemos generadores desde 5 KW hasta 1000 KW, ideales para eventos, construcción residencial, proyectos industriales y operaciones de emergencia. Todos nuestros equipos reciben mantenimiento preventivo constante.',
  },
  {
    id: 2,
    question: '¿Cuál es el tiempo mínimo de renta?',
    answer:
      'Manejamos rentas flexibles desde 1 día hasta contratos mensuales o anuales. Nuestros planes se adaptan a las necesidades específicas de tu proyecto, ofreciendo las mejores tarifas según el tiempo de renta.',
  },
  {
    id: 3,
    question: '¿Incluyen instalación y mantenimiento del equipo?',
    answer:
      'Sí, incluimos servicio de entrega e instalación en toda la zona sureste de México. Además, ofrecemos soporte técnico 24/7 y mantenimiento preventivo durante todo el periodo de renta para garantizar el funcionamiento óptimo del equipo.',
  },
  {
    id: 4,
    question: '¿A qué zonas dan servicio?',
    answer:
      'Operamos desde Veracruz y damos servicio a toda la zona sureste de México. Tenemos cobertura en Veracruz, Puebla, Orizaba, Xalapa, Poza Rica, Boca del Río, Tabasco, Chiapas, Campeche, Yucatán y Quintana Roo. Contamos con logística eficiente para entrega rápida en toda la región.',
  },
  {
    id: 5,
    question: '¿Qué sucede si el equipo falla durante la renta?',
    answer:
      'Contamos con soporte técnico disponible 24/7. En caso de falla, enviamos un técnico de inmediato o reemplazamos el equipo sin costo adicional. Nuestra prioridad es que tu proyecto no se detenga.',
  },
  {
    id: 6,
    question: '¿Ofrecen capacitación para operar el equipo?',
    answer:
      'Sí, nuestros expertos proporcionan capacitación básica sobre el uso seguro y eficiente del equipo al momento de la instalación. También ofrecemos manuales de operación y estamos disponibles para resolver cualquier duda.',
  },
  {
    id: 7,
    question: '¿Cómo puedo solicitar una cotización?',
    answer:
      'Puedes solicitar una cotización llenando nuestro formulario de contacto en esta página, llamándonos al 229 921 23 32, o escribiéndonos por WhatsApp. Nuestros especialistas te responderán en menos de 24 horas con una propuesta personalizada.',
  },
  {
    id: 8,
    question: '¿Qué métodos de pago aceptan?',
    answer:
      'Aceptamos transferencia bancaria y cheque. Para contratos empresariales ofrecemos facturación y términos de pago flexibles según el convenio establecido.',
  },
  {
    id: 9,
    question: '¿Cuál es la Política de Reemplazo y Soporte Técnico?',
    answer: `En Gensol, nuestro compromiso es garantizar la continuidad de tu proyecto. Entendemos que en la industria la energía no puede detenerse, por lo que contamos con una política de respuesta inmediata ante cualquier eventualidad técnica.

GARANTÍA DE FUNCIONAMIENTO: Todos nuestros equipos (generadores, torres de iluminación y soldadoras) son sometidos a rigurosas pruebas de mantenimiento antes de cada entrega. En caso de falla técnica de origen, procederemos con el reemplazo inmediato del equipo por uno de iguales o superiores características, sujeto a disponibilidad.

CONDICIONES PARA EL REEMPLAZO:
• Fallas Técnicas de Fábrica o Desgaste: El reemplazo sin costo aplica cuando la falla es inherente al funcionamiento mecánico o eléctrico del equipo.
• Exclusiones: No aplica si la falla es resultado de uso inadecuado (sobrecarga deliberada, falta de combustible adecuado, golpes accidentales o manipulación no autorizada).

PROTOCOLO DE REPORTE:
1. Enviar correo a logística@gensolver.com detallando la falla
2. Incluir número de serie del equipo (o ID de contrato), ubicación actual y evidencia fotográfica/video
3. Nuestro equipo coordinará la inspección técnica o envío de la unidad de reemplazo a la brevedad`,
  },
];
